// extracted by mini-css-extract-plugin
export default {"title":"MainContent_title__Gdo5V","welcome":"MainContent_welcome__J2NGG","choice":"MainContent_choice__tYU0y"};